import "@/styles/main.scss";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import { fa } from "vuetify/locale";
import light from "~/theme/light";

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    icons: {
      defaultSet: "mdi",
    },
    locale: {
      locale: "fa",
      fallback: "fa",
      messages: { fa },
      rtl: { fa: true },
    },
    theme: {
      themes: {
        light,
      },
    },
  });
  app.vueApp.use(vuetify);
});
